export default __webpack_public_path__ + "static/media/pasport-correct.d9620aed.png";